import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('sfension-currency') || 'EUR';
  });
  
  const [exchangeRate, setExchangeRate] = useState(() => {
    return Number(localStorage.getItem('sfension-exchange-rate')) || 120;
  });

  useEffect(() => {
    localStorage.setItem('sfension-currency', currency);
  }, [currency]);

  useEffect(() => {
    localStorage.setItem('sfension-exchange-rate', exchangeRate);
  }, [exchangeRate]);

  const toggleCurrency = () => {
    setCurrency(prev => prev === 'EUR' ? 'RSD' : 'EUR');
  };

  const formatPrice = (priceInEUR) => {
    const numValue = Number(priceInEUR) || 0;
    
    if (currency === 'RSD') {
      const rsdValue = numValue * exchangeRate;
      return `${new Intl.NumberFormat('sr-RS').format(Math.round(rsdValue))} RSD`;
    }
    
    return `${new Intl.NumberFormat('de-DE', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(numValue)} EUR`;
  };

  const formatPriceValue = (priceInEUR) => {
    const numValue = Number(priceInEUR) || 0;
    
    if (currency === 'RSD') {
      return Math.round(numValue * exchangeRate);
    }
    
    return numValue;
  };

  const getCurrencySymbol = () => currency;

  const value = {
    currency,
    setCurrency,
    exchangeRate,
    setExchangeRate,
    toggleCurrency,
    formatPrice,
    formatPriceValue,
    getCurrencySymbol
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};